import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BackBtn from '../Bonus/BackBtn';
import { useSelector } from 'react-redux';
import { Paper } from '@material-ui/core';
import StorefrontRoundedIcon from '@material-ui/icons/StorefrontRounded';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    paddingTop: theme.spacing(3),
  },
  logoContainer: {
    marginBottom: theme.spacing(2),
  },
  logoPaper: {
    position: 'relative',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1.5),
    maxWidth: '90%',
    minHeight: '132px',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-50%',
      left: '-50%',
      width: '200%',
      height: '200%',
      background:
        'linear-gradient(135deg, transparent 30%, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.3) 60%, #712f2f08 70%)',
      transform: 'translateX(-100%) translateY(-100%)',
      animation: '$shine 7s ease-in-out infinite',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(135deg, rgba(219,85,78,0.03) 0%, rgba(255,255,255,0) 50%, rgba(219,85,78,0.05) 100%)',
      pointerEvents: 'none',
    },
  },
  '@keyframes shine': {
    '0%': {
      transform: 'translateX(-100%) translateY(-100%)',
    },
    '15%': {
      transform: 'translateX(100%) translateY(100%)',
    },
    '100%': {
      transform: 'translateX(100%) translateY(100%)',
    },
  },
  logoImg: {
    height: '80px',
    width: '80px',
    objectFit: 'cover',
    borderRadius: theme.spacing(1),
  },
  noLogoImg: {
    height: '80px',
    width: '80px',
    borderRadius: theme.spacing(1),
    backgroundColor: '#eee',
  },
  storeNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  storeName: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#333',
  },
  storeIcon: {
    fontSize: '18px',
    color: '#db554e',
  },
  backBtn: {
    margin: theme.spacing(2, 'auto', 1),
  },
}));

const RestaurantLayout = (props) => {
  const classes = useStyles();
  const { backAction, showBackBtn, hideLogo, withLayout = true } = props;
  const { currentStore } = useSelector((state) => state.loginState);

  if (!withLayout) {
    return <>{props.children}</>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        {hideLogo !== true && (
          <Paper className={classes.logoPaper} elevation={0}>
            {currentStore && (
              <img src={currentStore.imgSrc} className={classes.logoImg} />
            )}

            {!currentStore && <div className={classes.noLogoImg} />}

            <div className={classes.storeNameContainer}>
              <StorefrontRoundedIcon className={classes.storeIcon} />
              <span className={classes.storeName}>
                {currentStore ? currentStore.name : '無分店'}
              </span>
            </div>
          </Paper>
        )}

        {showBackBtn && (
          <div className={classes.backBtn}>
            <BackBtn backAction={backAction} />
          </div>
        )}
      </div>

      {props.children}
    </div>
  );
};

export default RestaurantLayout;
